import React from 'react'
import { PLACEHOLDER, STRING } from '../../../../utils/Constant'
import DatePicker from 'react-datepicker';
import TransactionPopup from '../../Popup/transactionpopup';
import TransactionPopupNew from '../../Popup/TransactionPopupNew'
import TransactionPopupNewCashCreditjar from '../../Popup/TransactionPopupNewCashCreditjar'
import NoData from '../../../../images/nodata.png'
import SampleRefundImage from '../../../../images/SampleRefundImage.png'
import { ABHICASH_LIKE, ABHICASH_ONLY, CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, Company_DATA, CREDFIN_LIKE, CREDITJAR_LIKE, PAYDAY_LIKE } from '../../../../layouts/MainTenantconfig';
import moment from 'moment';
const TransactionDetails = ({ addPoup, viewPage, pageHandler, billDeskData, editTransHandler, saveTransHandler, trnsDateState, details,
    openPopup, DeleteTransaction, transDetail, openAddPopup, close, PaymentLinkData, handleExpireBtnchange, convertDate, updatedComment, handleUpdatedcomment, handleSavecomment, allDetail, admin, tenant, FetchDataById, showTransactionSaveBtn, openupLoadPopup, uploadPopup, handleUploadFileChange, refundUploadedFile, UploadRefundHandler }) => (
    <div className=" details-new" style={{ border: '1.5px solid #DBE9FF', borderRadius: '5px', padding: '10px', marginTop: '20px', minHeight: '400px' }}>

        {/* <div className='row '>
           <button  onClick={()=>pageHandler('txn')} className={viewPage==='txn'?'btn btn-primary':'btn btn-default'}>Transaction</button>&nbsp;&nbsp;
           <button onClick={()=>pageHandler('billdesk')} className={viewPage==='billdesk'?'btn btn-primary':'btn btn-default'}>Billdesk Transaction</button>

        </div> */}
        {addPoup ?
            CHECK_COMPANY_TENANT(ABHICASH_ONLY) || CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?
                <TransactionPopupNew close={close} allDetail={allDetail} admin={admin} />
                : CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) || CHECK_COMPANY_TENANT(PAYDAY_LIKE) ?
                    <TransactionPopupNewCashCreditjar close={close} allDetail={allDetail} admin={admin} />
                    :
                    <TransactionPopup close={close} editTransHandler={editTransHandler} saveTransHandler={saveTransHandler} trnsDateState={trnsDateState} transDetail={transDetail} FetchDataById={FetchDataById} showTransactionSaveBtn={showTransactionSaveBtn} />

            : ""}
        <div className='row'>
            <div className='col-sm-6 col-xs-12'>

                <div className="btn-group btn-grp-own" role="group" aria-label="onboard-btn" style={{ marginTop: '10px', padding: '10px' }}>
                    <button className={`btn btn-outline-primary ${viewPage == "txn" ? "activeBtnLoanReportSection" : ""}`} onClick={() => pageHandler('txn')}> Razorpay & Others </button>
                    <button className={`btn btn-outline-primary ${viewPage == "billdesk" ? "activeBtnLoanReportSection" : ""}`} onClick={() => pageHandler('billdesk')} > Billdesk </button>
                    <button className={`btn btn-outline-primary ${viewPage == "PaymentLink" ? "activeBtnLoanReportSection" : ""}`} onClick={() => pageHandler('PaymentLink')} > Payment Link </button>

                </div>
            </div>
            {
                CHECK_COMPANY_TENANT(ABHICASH_LIKE) || CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(PAYDAY_LIKE) ?
                    <div className='col-sm-6 col-xs-12 text-right'>
                        {
                            CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                                <button className='btn btn-primary' style={{ marginTop: '20px', color: '#fff', marginRight: '5px' }} onClick={() => openupLoadPopup(true)}><i className='fa fa-plus-circle'></i>&nbsp;&nbsp;Refund</button>
                                : ""}
                        <button className='btn btn-primary' style={{ marginTop: '20px', color: '#fff' }} onClick={() => openAddPopup()}><i className='fa fa-plus-circle'></i>&nbsp;&nbsp;Add Transaction</button>
                    </div>
                    : ''}
        </div>
        {viewPage === 'txn' ?
            details != null && details != '' && details.length > 0 ?
                <div className=" form-group overflow-auto phocket-table-new " style={{ marginBottom: '20px' }}>
                    {/* <h3 className="text-center">Transaction History</h3> */}
                    <table>
                        <thead>
                            {
                                CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                                    <tr>
                                        <th>ID</th>
                                        <th>DATE</th>
                                        <th>MODE</th>
                                        <th>AMOUNT</th>
                                        <th>STATUS</th>
                                        <th>PAYMENT TYPE</th>
                                        <th>PAYMENT GATEWAY</th>
                                        <th>COMMENT</th>
                                        <th>UPDATE COMMENT</th>
                                        {
                                            CHECK_COMPANY_TENANT(ABHICASH_ONLY) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                                                <th>VIEW RECEIPT</th>
                                                : ""}
                                        {/* <th>UPDATE</th> */}
                                        {/* <th>DELETE</th> */}
                                    </tr>
                                    :
                                    <tr>
                                        <th>ID</th>
                                        <th>DATE</th>
                                        <th>MODE</th>
                                        <th>AMOUNT</th>
                                        <th>STATUS</th>
                                        {
                                            CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                                                <>
                                                    <th>REFUND DATE</th>
                                                    <th>REFUND AMOUNT</th>
                                                    <th>REFUND STATUS</th>
                                                </>
                                                : ""}
                                        <th>COMMENT</th>
                                        <th>UPDATE COMMENT</th>
                                        {
                                            CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                                                <th>VIEW RECEIPT</th>
                                                : ""}
                                        <th>UPDATE</th>
                                        <th>DELETE</th>
                                    </tr>
                            }
                        </thead>

                        <tbody>
                            {Array.isArray(details) && details != null && details != '' && details.length > 0 ? details.map((detail, i) => {
                                return (
                                    <>
                                        {
                                            CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                                                <tr key={i}>
                                                    <td>{detail.transactionId}</td>
                                                    <td>{detail.transactionDate}</td>
                                                    <td>{detail.paymentMode}</td>
                                                    <td>{detail.amount}</td>
                                                    <td>{detail.paymentStatus}</td>
                                                    <td>{detail.paymentType}</td>
                                                    <td>{detail.paymentGateway}</td>
                                                    <td>{detail.comment}</td>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <input style={{ border: '1px solid #000', padding: '8px', borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} value={updatedComment[detail.transactionId] ?? ""} onChange={(e) => handleUpdatedcomment(e.target.value, detail.transactionId)} />
                                                            <button className="btn-primary" style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', marginBottom: '0' }} onClick={() => handleSavecomment(detail.transactionId)}>Save</button>
                                                        </div>
                                                    </td>
                                                    {
                                                        CHECK_COMPANY_TENANT(ABHICASH_ONLY) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                                                            <td>
                                                                <a href={tenant?.WEB_URL + "transactionReciept/" + detail?.transactionId} target='_blank'>
                                                                    <span className="fa fa-eye" style={{ cursor: 'pointer', color: '#267dff' }} />
                                                                </a>
                                                            </td>
                                                            : ""}
                                                    {/* <td><span className="fa fa-edit" style={{ cursor: 'pointer' }} onClick={(e) => openPopup(e, detail.transactionId)} /></td> */}
                                                    {/* <td><span className="fa fa-trash" style={{ cursor: 'pointer' }} onClick={(e) => DeleteTransaction(detail)} /></td> */}
                                                </tr>
                                                :
                                                <tr key={i}>
                                                    <td>{detail.transactionId}</td>
                                                    <td>{detail.prepayDate}</td>
                                                    <td>{detail.paymentMode}</td>
                                                    <td>{detail.prepayAmount}</td>
                                                    <td>{detail.status}</td>
                                                    {
                                                        CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                                                            <>
                                                                <td>{detail.refundDate !== null && detail.refundDate !== undefined && detail.refundDate !== "" ? moment(detail.refundDate).format("DD-MM-YYYY") : ""}</td>
                                                                <td>{detail.refundAmount}</td>
                                                                <td>{detail.refundStatus}</td>
                                                            </>
                                                            : ""}
                                                    <td>{detail.comment}</td>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <input style={{ border: '1px solid #000', padding: '8px', borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} value={updatedComment[detail.transactionId] ?? ""} onChange={(e) => handleUpdatedcomment(e.target.value, detail.transactionId)} />
                                                            <button className="btn-primary" style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px', marginBottom: '0' }} onClick={() => handleSavecomment(detail.transactionId)}>Save</button>
                                                        </div>
                                                    </td>
                                                    {
                                                        CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                                                            <td>
                                                                <a href={tenant?.WEB_URL + "transactionReciept/" + detail?.transactionId} target='_blank'>
                                                                    <span className="fa fa-eye" style={{ cursor: 'pointer', color: '#267dff' }} />
                                                                </a>
                                                            </td>
                                                            : ""}
                                                    <td><span className="fa fa-edit" style={{ cursor: 'pointer' }} onClick={(e) => openPopup(e, detail.transactionId)} /></td>
                                                    <td><span className="fa fa-trash" style={{ cursor: 'pointer' }} onClick={(e) => DeleteTransaction(detail)} /></td>
                                                </tr>
                                        }
                                    </>
                                )
                            })
                                : null}
                        </tbody>
                    </table>
                </div>
                : <div className='text-center'><img style={{ width: '30%' }} src={NoData} /></div> : ""}
        {viewPage === 'billdesk' ?
            billDeskData != null && billDeskData != '' && billDeskData.length > 0 ?
                <div className=" form-group overflow-auto phocket-table-new" style={{ marginBottom: '20px' }}>
                    {/* <h3 className="text-center">Billdesk Transaction History</h3> */}
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>DATE</th>
                                <th>AMOUNT</th>
                                <th>Transaction Error Description</th>
                            </tr>
                        </thead>

                        <tbody>
                            {billDeskData != null && billDeskData != '' && billDeskData.length > 0 ? billDeskData.map((detail, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{detail.bdOrderId}</td>
                                        <td>{detail.addedOn}</td>
                                        <td>{detail.amount}</td>
                                        <td>{detail.transactionErrDesc}</td>

                                    </tr>
                                )
                            })
                                : null}
                        </tbody>
                    </table>
                </div>
                : <div className='text-center'><img style={{ width: '30%' }} src={NoData} /></div> : ""}
        {viewPage === 'PaymentLink' ?
            PaymentLinkData !== null && PaymentLinkData !== '' && PaymentLinkData.length > 0 ?
                <div className=" form-group overflow-auto phocket-table-new" style={{ marginBottom: '20px' }}>
                    {/* <h3 className="text-center">Billdesk Transaction History</h3> */}
                    <table>
                        <thead>

                            <tr>
                                <th style={{ textAlign: 'center' }}>Payment Id</th>
                                <th style={{ textAlign: 'center' }}>Date</th>
                                <th style={{ textAlign: 'center' }}>Payment Type</th>
                                <th style={{ textAlign: 'center' }}>Amount</th>
                                <th style={{ textAlign: 'center' }}>Payment Link</th>
                                <th style={{ textAlign: 'center' }}>Created By</th>
                                <th style={{ textAlign: 'center' }}>Deactivate Payment Link</th>
                            </tr>

                        </thead>
                        <tbody>
                            {PaymentLinkData !== null && PaymentLinkData !== '' && PaymentLinkData.length > 0 ? PaymentLinkData.map((detail, i) => {
                                return (
                                    <>
                                        {
                                            CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                                                <tr key={i} style={{ textAlign: 'center' }}>
                                                    <td>{detail?.paymentId}</td>
                                                    <td>{detail?.createdDate != null && detail?.createdDate != undefined && detail?.createdDate != '' ? convertDate(detail?.createdDate) : ''}</td>
                                                    <td>{detail?.paymentType === 'FULL_PAYMENT' ? 'Full Payment' : 'Part Payment'}</td>
                                                    <td>{detail?.amount}</td>
                                                    <td>{detail?.paymentLink}</td>
                                                    <td>{detail?.createdBy}</td>
                                                    {
                                                        detail?.active ?

                                                            <td>

                                                                <div style={{ textAlign: 'center' }}>
                                                                    <button style={{ width: '50%', padding: '8px 5px', background: '#267DFF', border: 'none', borderRadius: '6px', color: '#fff' }} onClick={(e) => handleExpireBtnchange(e, detail)}>Expire</button>
                                                                </div>
                                                            </td>
                                                            :
                                                            <td>Expired</td>}

                                                </tr>
                                                :
                                                <tr key={i} style={{ textAlign: 'center' }}>
                                                    <td>{detail?.paymentId}</td>
                                                    <td>{detail?.createdAt != null && detail?.createdAt != undefined && detail?.createdAt != '' ? convertDate(detail?.createdAt) : ''}</td>
                                                    <td>{detail?.paymentType === 'fullpayment' ? 'Full Payment' : 'Part Payment'}</td>
                                                    <td>{detail?.amount}</td>
                                                    <td>{detail?.shortUrl}</td>
                                                    <td>{detail?.createdBy}</td>
                                                    {
                                                        detail?.active ?

                                                            <td>

                                                                <div style={{ textAlign: 'center' }}>
                                                                    <button style={{ width: '50%', padding: '8px 5px', background: '#267DFF', border: 'none', borderRadius: '6px', color: '#fff' }} onClick={(e) => handleExpireBtnchange(e, detail)}>Expire</button>
                                                                </div>
                                                            </td>
                                                            :
                                                            <td>Expired</td>}

                                                </tr>
                                        }

                                    </>
                                )
                            })
                                : null}
                        </tbody>
                    </table>
                </div>
                : <div className='text-center'><img style={{ width: '30%' }} src={NoData} /></div> : ""}

        {
            uploadPopup ?
                <div className="background-blur details-new">

                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border" style={{ marginTop: '100px', width: '50%' }}>

                        <div style={{ textAlign: 'right', cursor: 'pointer' }}>
                            <i className="fa fa-times" onClick={() => openupLoadPopup(false)}></i>
                        </div>
                        <h4 style={{ color: '#000', marginTop: '-15px', textAlign: 'center' }}>UPLOAD REFUND</h4>

                        <div className="row form-group" style={{ marginTop: '20px' }}>
                            <div className="col-sm-6 col-xs-12">
                                <div
                                    style={{
                                        backgroundColor: "#e6f0ff",
                                        padding: "30px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "8px",
                                        width: "100%",

                                        position: "relative", // Important for input overlay
                                    }}
                                >
                                    <div
                                        onClick={() => document.getElementById("refundFileInput").click()}
                                        style={{
                                            border: "2px dashed #006fbc",
                                            padding: "20px 40px",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            color: "#006fbc",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <span style={{ fontSize: "18px" }}>☁️</span>
                                        {refundUploadedFile === "" ? "Click here to Upload" : refundUploadedFile?.name}
                                    </div>
                                    <input
                                        id="refundFileInput"
                                        type="file"
                                        onChange={(e) => handleUploadFileChange(e)}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            opacity: 0,
                                            cursor: "pointer",
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-sm-6 col-xs-12">
                                <div>
                                    <img src={SampleRefundImage} alt="Sample Refund" width="100%" />
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-primary" style={{ marginTop: '20px' }} id="transSubmitBtn"
                            onClick={e => UploadRefundHandler()}
                        >
                            Upload
                        </button>
                    </div>
                </div>
                : ""}
    </div>
)

export default TransactionDetails;